"use client";

import { parseAsStringEnum, useQueryState } from "nuqs";
import { useI18n } from "@/locales/client";
import { MODES, VALID_MODES } from "../types";

export function useMode() {
  const t = useI18n();
  const [mode, setMode] = useQueryState(
    "mode",
    parseAsStringEnum(VALID_MODES).withDefault(MODES.multiple_choice.value),
  );

  const currentMode = {
    ...MODES[mode],
    label: t(`quizMode.modes.${mode}`),
  };

  return { mode: currentMode, changeMode: setMode };
}
